import LoginPage from '../../../components/molecules/forms/loginPage';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';
import { login } from '../../../redux/loader/cart';

const LoginPageTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return <LoginPage onLogin={login} data={data} />;
};

export default tastify({ translate: true, connect: { context: true }})(LoginPageTastic);
